package fr.frux.navigation

import androidx.compose.runtime.withFrameNanos
import fr.frux.core.maps.Location
import fr.frux.feature.map.aim.MapAimState
import fr.frux.feature.treeadd.wizard.TreeWizardAim
import fr.frux.shared.domain.model.DuplicateCandidate
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch

/**
 * Adapte le mode visée de la carte persistante au contrat de l'assistant, sans que les deux
 * modules `feature-*` se connaissent. Avec [scope], [TreeWizardAim.start] attend une frame (et
 * [stillWanted], la route courante) : le décalage de l'épingle est écrit par un effet de la carte,
 * qui peut passer après celui de l'assistant au premier rendu de la colonne grand écran.
 */
fun MapAimState.asWizardAim(
    scope: CoroutineScope? = null,
    stillWanted: () -> Boolean = { true },
): TreeWizardAim = WizardAimAdapter(this, scope, stillWanted)

private class WizardAimAdapter(
    private val aim: MapAimState,
    private val scope: CoroutineScope?,
    private val stillWanted: () -> Boolean,
) : TreeWizardAim {
    private var pendingStart: Job? = null

    override val candidate: DuplicateCandidate? get() = aim.candidate

    override fun currentTarget(): Location? = aim.currentTarget()

    override fun start(center: Location?) {
        pendingStart?.cancel()
        if (scope == null) {
            aim.start(center)
            return
        }
        pendingStart =
            scope.launch {
                withFrameNanos { }
                // La route a pu changer pendant la frame : jamais de visée hors de l'assistant.
                if (stillWanted()) aim.start(center)
            }
    }

    override fun showFrozen(location: Location?) = aim.showFrozen(location)

    override fun stop() {
        pendingStart?.cancel()
        pendingStart = null
        aim.stop()
    }
}
